import styled from 'styled-components';
import { motion, useInView } from 'motion/react';
import React, { PropsWithChildren, useRef } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionGridBlockProps extends PropsWithChildren {
  duration?: number;
  delay?: number;
  className?: string;
}

export const MotionGridBlock = ({
  children,
  duration = ANIMATION_CONFIG.gridBlock.duration,
  delay = ANIMATION_CONFIG.gridBlock.delay,
  className,
}: MotionGridBlockProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.gridBlock.amount,
  });

  return (
    <MotionWrapper
      ref={ref}
      className={className}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.gridBlock.scale }
      }
      transition={{
        duration: duration,
        delay: delay,
      }}
    >
      {children}
    </MotionWrapper>
  );
};

const MotionWrapper = styled(motion.div)``;
